import PortugalIdCard from './PortugalIdCard';

export default PortugalIdCard;
